import qs from 'query-string';

export const DEFAULT_PAGE_SIZE = 10;

export function getSearchParamsURL(
  SearchableText = '',
  sortOn = 'relevance',
  currentPage = 1,
  docTypesFilter = '',
  domainsFilter = '',
  getObject = false,
) {
  let baseUrl = '';

  const queryObject = {
    SearchableText: SearchableText,
    sorting: sortOn,
    actual_page: currentPage ?? 1,
    pagination_size: DEFAULT_PAGE_SIZE,
    selected_facet_type: docTypesFilter,
    selected_facet_domain: domainsFilter,
  };

  if (getObject) {
    return {
      ...queryObject,
      SearchableText: undefined, // Serve differenziare il parametro che ricevo in get e quello che mando a searcher
      terms: SearchableText ?? '',
    };
  }

  return baseUrl + '?' + qs.stringify(queryObject);
}
